export default __webpack_public_path__ + "static/media/home1.1cb5a0af.jpg";